module.exports = {
          srcSet: "/media/baby.webp"+" 740w",
          images:[ {path: "/media/baby.webp",width: 740,height: 970}],
          src: "/media/baby.webp",
          toString:function(){return "/media/baby.webp"},
          
          width: 740,
          height: 970
        }